var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBtnEditTable = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.90659 2.43682H2.34035C1.91857 2.43682 1.51405 2.60438 1.2158 2.90263C0.917554 3.20088 0.75 3.60539 0.75 4.02718V15.1596C0.75 15.5814 0.917554 15.9859 1.2158 16.2842C1.51405 16.5824 1.91857 16.75 2.34035 16.75H13.4728C13.8946 16.75 14.2991 16.5824 14.5974 16.2842C14.8956 15.9859 15.0632 15.5814 15.0632 15.1596V9.59341M13.8704 1.24406C14.1868 0.927718 14.6158 0.75 15.0632 0.75C15.5105 0.75 15.9396 0.927718 16.2559 1.24406C16.5723 1.5604 16.75 1.98945 16.75 2.43682C16.75 2.8842 16.5723 3.31325 16.2559 3.62959L8.70176 11.1838L5.52106 11.9789L6.31624 8.79824L13.8704 1.24406Z",
  stroke: "#3E4248",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBtnEditTable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_btn_edit_table.650c97f4f286e0b341082f69e2e8497f.svg";